'use client';

import {useTranslation} from 'react-i18next';
import type {DetailPageAnalytics, TrackedItem} from '../../analytics';
import {useLocale} from '../../i18n';
import type {PhaseCardView} from '../../model';
import {phaseHref} from '../../routing';
import {ListingCarousel} from '../listing';
import {Section} from '../primitives';
import {PhaseCard} from './PhaseCard';

export interface DetailPhasesCarouselProps {
  phases: PhaseCardView[];
  analytics: DetailPageAnalytics;
  parentTracked: TrackedItem;
  onRegisterInterest: (phase: PhaseCardView) => void;
  viewAllHref?: string;
}

export function DetailPhasesCarousel({phases, analytics, parentTracked, onRegisterInterest, viewAllHref}: DetailPhasesCarouselProps) {
  const {t} = useTranslation();
  const locale = useLocale();
  if (phases.length === 0) {
    return null;
  }

  return (
    <Section tone="subtle">
      <ListingCarousel
        title={t('all_phases')}
        viewAll={
          viewAllHref
            ? {
                label: t('view_all'),
                href: viewAllHref,
                onClick: () => {
                  analytics.viewAll(parentTracked, 'phases');
                },
              }
            : undefined
        }
      >
        {phases.map(phase => (
          <PhaseCard
            key={phase.uuid}
            phase={phase}
            href={phaseHref(locale, phase.uuid)}
            analytics={analytics}
            onRegisterInterest={onRegisterInterest}
          />
        ))}
      </ListingCarousel>
    </Section>
  );
}

DetailPhasesCarousel.displayName = 'DetailPhasesCarousel';
